module.exports = __webpack_public_path__ + "static/media/story-29.5cf6a111.jpg";